const PREFIX = 'TAG'

export const TAG_LOADING_STATUS = `${PREFIX}_LOADING_STATUS`
export const TAG_FETCH = `${PREFIX}_FETCH`
export const TAG_FETCH_ERRORS = `${PREFIX}_FETCH_ERRORS`

export const TAG_CLEAR = `${PREFIX}_CLEAR`
export const TAG_DEFAULT_STRUCTURE = `${PREFIX}_DEFAULT_STRUCTURE`

export const TAG_FETCH_POPULAR = `${PREFIX}_FETCH_POPULAR`
export const TAG_FETCH_POPULAR_ERROR = `${PREFIX}_FETCH_POPULAR_ERROR`

export const TAG_DELETE_LOADING = `${PREFIX}_DELETE_LOADINGS`
export const TAG_DELETE = `${PREFIX}_DELETE`
export const TAG_DELETE_ERRORS = `${PREFIX}_DELETE_ERRORS`

export const TAG_ADD_LOADING = `${PREFIX}_ADD_LOADINGS`
export const TAG_ADD = `${PREFIX}_ADD`
export const TAG_ADD_ERRORS = `${PREFIX}_ADD_ERRORS`

